import React, { Fragment } from "react";
import { ButtonBranded } from "../molecules/ButtonBrande";
import { Listbox, Label, ListboxOptions } from "@headlessui/react";
import { OptionsBranded } from "../molecules/OptionsBraded";

type option = {
  id: string | number;
  title: string;
  description: string;
  function: () => void;
};

type BrandedProps = {
  title?: string;
  publishingOptions: option[];
};

export const Branded: React.FC<BrandedProps> = ({
  title,
  publishingOptions,
}) => (
  <Fragment>
    <Listbox>
      <Label className="sr-only">{title}</Label>
      {/* Etiqueta oculta para accesibilidad */}
      <div className="relative">
        {" "}
        {/* Contenedor relativo */}
        <ButtonBranded texto="Prueba" textoSeleccionado={title} />
        <ListboxOptions
          transition
          className="absolute right-2 z-50 mt-2 w-72 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          {publishingOptions.map((option) => (
            <OptionsBranded key={option.id} option={option} />
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  </Fragment>
);
